import React from "react";
import { BaseSvgIcon, createIcon } from "../IconBase";
// GENERATED from custom/src/two_column_layout.svg by scripts/generate-icons.mjs. Do not edit
// by hand — edit the source SVG and regenerate.
const TwoColumnLayoutIconGlyph = (props) => (React.createElement(BaseSvgIcon, { ...props },
    React.createElement("rect", { x: "2", y: "2", width: "6", height: "20", rx: "1", fill: "currentColor" }),
    React.createElement("rect", { x: "10", y: "2", width: "12", height: "20", rx: "1", fill: "currentColor" })));
export const TwoColumnLayoutIcon = createIcon(TwoColumnLayoutIconGlyph, "TwoColumnLayoutIcon", "0 0 24 24");
//# sourceMappingURL=TwoColumnLayoutIcon.js.map